import { SseService } from './../../../core/services/sse.service';
import { ComplaintsService } from './../../../core/services/complaints.service';
import * as fromComplaintsActions from './complaints.actions';
import { mergeMap, map, catchError, tap, switchMap } from 'rxjs/operators';
import { Actions, createEffect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { of, EMPTY } from 'rxjs';
import { Denounce } from '../../../core/models/denounce.model';

@Injectable()
export class ComplaintsEffects {
	constructor(
		private actions$: Actions,
		private complaintsService: ComplaintsService,
		private sseService: SseService
	) {}

	loadList$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromComplaintsActions.loadComplaints),
			mergeMap(() => {
				return this.complaintsService.getComplaints({ paginate: true }).pipe(
					map((complaints) => {
						return fromComplaintsActions.loadComplaintsSuccess({ complaints });
					}),
					catchError((error) => {
						return of(fromComplaintsActions.loadComplaintsFailure({ error }));
					})
				);
			})
		)
	);

	// loadComplaintsPerPeriod$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(fromComplaintsActions.loadComplaintsPerPeriod),
	// 		mergeMap(() => {
	// 			const from = '2020-01-01';
	// 			let date = new Date();
	// 			let currentYear = date.getFullYear();
	// 			const to = `${currentYear}-12-31`;

	// 			return this.complaintsService.getComplaintsPerPeriod(from, to).pipe(
	// 				map((complaints) => {
	// 					return fromComplaintsActions.loadComplaintsPerPeriodSuccess({
	// 						complaints,
	// 					});
	// 				}),
	// 				catchError((error) => {
	// 					return of(fromComplaintsActions.loadComplaintsPerPeriodFailure());
	// 				})
	// 			);
	// 		})
	// 	)
	// );

	loadPartialComplaintsPerPeriod$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromComplaintsActions.loadPartialComplaintsPerPeriod),
			mergeMap((props) => {
				return this.complaintsService.getPartialComplaints(props.from).pipe(
					map((complaints) => {
						if (complaints.length > 0) {
							return fromComplaintsActions.loadPartialComplaintsPerPeriodSuccess(
								{
									complaints,
								}
							);
						} else {
							return fromComplaintsActions.loadpartialComplaintsPerPeriodEmpty();
						}
					}),
					catchError((error) =>
						of(fromComplaintsActions.loadPartialComplaintsPerPeriodFailure())
					)
				);
			})
		)
	);

	loadBusLines$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromComplaintsActions.loadBusLines),
			mergeMap((props) => {
				return this.complaintsService.getBusLines().pipe(
					map((busLines) => {
						return fromComplaintsActions.loadBusLinesSuccess({ busLines });
					}),
					catchError((error) => {
						return of(fromComplaintsActions.loadBusLinesFailure());
					})
				);
			})
		)
	);

	connectSse$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromComplaintsActions.connectSse),
			tap(() => {
				try {
					let sse = this.sseService.getSse();
					return fromComplaintsActions.connectSseSuccess(sse);
				} catch (e) {
					return of(fromComplaintsActions.connectSseFailure());
				}
			})
		)
	);
}
